import { render, staticRenderFns } from "./goodsReport.vue?vue&type=template&id=54ca1444&scoped=true"
import script from "./goodsReport.vue?vue&type=script&lang=js"
export * from "./goodsReport.vue?vue&type=script&lang=js"
import style0 from "./goodsReport.vue?vue&type=style&index=0&id=54ca1444&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ca1444",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54ca1444')) {
      api.createRecord('54ca1444', component.options)
    } else {
      api.reload('54ca1444', component.options)
    }
    module.hot.accept("./goodsReport.vue?vue&type=template&id=54ca1444&scoped=true", function () {
      api.rerender('54ca1444', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reportCenter/goodsReport.vue"
export default component.exports